/* =========================================================================
   DEX · Theme initialiser — light mode locked
   FIX-HOMEPAGE-DARK-MODE-REGRESSION-003 (2026-04-24)

   The previous time-zone-aware switcher applied [data-theme="dark"] after
   18:00 local time or whenever the OS preferred dark mode. This caused a
   full-site dark-mode regression. DEX is a light-mode institutional site
   (Corporate Blue colour system, Layer 1). Dark mode is not a supported
   site experience at this time.

   This file locks data-theme="light" unconditionally on every page load.
   It clears any stale localStorage value from the old switcher so
   returning visitors are not served a cached "dark" preference.

   The window.DEXTheme API surface is preserved so any [data-theme-toggle]
   buttons in the DOM do not error, but they have no effect on the theme.
   ========================================================================= */
(function () {
  var STORAGE = 'dex-theme';

  // Clear any stale dark/auto preference from the previous switcher.
  localStorage.removeItem(STORAGE);

  // Lock to light unconditionally. Set synchronously before first paint.
  var root = document.documentElement;
  root.setAttribute('data-theme', 'light');
  root.setAttribute('data-theme-mode', 'light');

  // Expose a no-op compatible API so existing button references do not throw.
  window.DEXTheme = {
    get: function () { return 'light'; },
    set: function () {},
    cycle: function () {},
    resolve: function () { return 'light'; }
  };
})();
